const baseApi = "https://nawodhan.kabco.co.in"
export { baseApi }